/**
 * Message from a failed API call, for display to the operator.
 *
 * The generated client sets `throwOnError: true`, so a mutation rejects with the
 * parsed error body — `{ status: 'error', error: { message } }` — not an Error.
 * Rendering a hardcoded fallback instead threw away messages written precisely
 * so the operator knows what to do: which HeyReach workspace still has to be
 * deleted, which startup holds a balance, which org has other members.
 *
 * Falls back only when the response carries nothing useful.
 */
export function apiErrorMessage(error: unknown, fallback: string): string {
  if (error && typeof error === 'object') {
    const body = error as { error?: { message?: unknown }; message?: unknown }
    if (typeof body.error?.message === 'string' && body.error.message.trim()) {
      return body.error.message
    }
    if (typeof body.message === 'string' && body.message.trim()) return body.message
  }
  return fallback
}
